<div class="d-flex align-items-center gap-2 p-3 fs-6">
  <div>{{ 'RESULTS' | translate }}:</div>
  <div class="mr-2">{{ from }} - {{ to }} {{ 'OF' | translate }} {{ paginationMeta()?.total }}</div>
  <div><i class="fas fa-angle-left fa-lg" [class.cursor-pointer]="from != 0" (click)="previous()"></i></div>
  <div><i class="fas fa-angle-right fa-lg cursor-pointer" [class.cursor-pointer]="to != paginationMeta()?.total"
          (click)="next()"></i>
  </div>
</div>
